import { createActionRoute, createSiteRoute } from '@townsquare/router/create-route';
import { SiteHomePageRoute } from '@townsquare/router/route-types';

export const lookupRedirectActionRoute: SiteHomePageRoute = createSiteRoute(
	createActionRoute({
		exact: true,
		name: 'lookupRedirectAction',
		path: '/lookup/:key',
	}),
);
